import { render, staticRenderFns } from "./sample-type-selector.vue?vue&type=template&id=f7878868&"
import script from "./sample-type-selector.vue?vue&type=script&lang=js&"
export * from "./sample-type-selector.vue?vue&type=script&lang=js&"
import style0 from "./sample-type-selector.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports